import dayjs from 'dayjs';

import { diffDay, addDays, getToday, NO_START, NO_END } from '@ha/date';

interface Exclusion {
  from: string;
  to: string;
}

export default (startDate: string, endDate: string): Exclusion => {
  const today = getToday();
  const diffTodayStart = diffDay(today, startDate);
  const diffTodayEnd = diffDay(today, endDate);

  if (diffTodayStart < 0) {
    return {
      from: today,
      to: addDays(dayjs(startDate).toISOString(), -1),
    };
  }

  if (diffTodayEnd >= 0) {
    return { from: NO_START, to: NO_END };
  }

  return { from: NO_START, to: NO_START };
};
